import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.new.spacing.large,
    marginTop: theme.new.spacing.medium,
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'none',
      gridAutoFlow: 'column',
      gridAutoColumns: 'minmax(0, 1fr)',
    },
  },
  tile: {
    border: `1px solid ${theme.new.color.line.hairline}`,
    borderRadius: theme.new.shape.borderRadius.medium,
    padding: theme.new.spacing.medium,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.xsmall,
  },
  labelRow: {
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  count: {
    lineHeight: 1.3,
  },
  tileOpensTab: {
    position: 'relative',
  },
  // Sibling of the tile content, not its parent, so the info icon is never nested in a button.
  tileOverlay: {
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: theme.new.color.brandTertiary,
    },
  },
  aboveOverlay: {
    position: 'relative',
    pointerEvents: 'none',
    '& button': {
      pointerEvents: 'auto',
    },
  },
  enrolled: {
    color: theme.new.color.brandPrimary,
  },
  errors: {
    color: theme.new.color.errorPrimary,
  },
  pending: {
    color: theme.new.color.warningPrimary,
  },
  eligible: {
    color: theme.new.color.successPrimary,
  },
}));

export default useStyles;
